var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import { memo } from 'react';
import * as React from "react";
var SvgComma16 = /*#__PURE__*/memo(function (props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.816 15.128c2.464-1.6 3.696-3.2 3.696-4.8 0-.384-.192-.576-.576-.576H8.84l-.384.048-.672.096C5.928 9.896 5 9.144 5 7.64 5 5.88 5.864 5 7.592 5c2.432 0 3.648 1.44 3.648 4.32 0 1.344-.592 2.704-1.776 4.08-1.152 1.376-2.24 2.224-3.264 2.544l-.384-.816Z"
  })));
});
SvgComma16.displayName = "SvgComma16";
export default SvgComma16;